import {
    CHARGES_LIST,
    CHARGES_LIST_SUCCESS,
    CHARGES_LIST_ERROR,
    CHARGES_DDLIST,
    CHARGES_DDLIST_SUCCESS,
    CHARGES_DDLIST_ERROR,
    CHARGES_GETLIST,
    CHARGES_GETLIST_SUCCESS,
    CHARGES_GETLIST_ERROR,
} from '../types';

const initialState = {
    charges: [],
    charge: {},
    loading: false,
    error: false
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case CHARGES_LIST:
            return {
                ...state,
                loading: true,
                charge: {},
            }
        case CHARGES_LIST_SUCCESS:
            return {
                ...state,
                charges: action.payload,
                charge: {},
                loading: false,
                error: false,
            }
        case CHARGES_LIST_ERROR:
            return {
                ...state,
                charges: [],
                charge: {},
                loading: false,
                error: true,
            }
        case CHARGES_DDLIST:
            return {
                ...state,
                loading: true,
                charge: {}
            }
        case CHARGES_DDLIST_SUCCESS:
            return {
                ...state,
                charges: action.payload,
                loading: false,
                error: false
            }
        case CHARGES_DDLIST_ERROR:
            return {
                ...state,
                charges: [],
                loading: false,
                error: true,
                charge: {}
            }
        case CHARGES_GETLIST:
            return {
                ...state,
                loading: true,
                charge: {}
            }
        case CHARGES_GETLIST_SUCCESS:
            return {
                ...state,
                charges: action.payload,
                loading: false,
                error: false
            }
        case CHARGES_GETLIST_ERROR:
            return {
                ...state,
                charges: [],
                loading: false,
                error: true,
                charge: {}
            }
        default:
            return state;
    }
}
